import { Table } from "containers/Table";
import {
  Button,
  Container,
  ContainerInputPesquisa,
  DivAcoes,
  Header,
  Icon,
  InputPesquisa,
  InputWrapper,
  TextoHeader,
} from "./style";
import { IProcessoVincularLote } from "../../../interface/IProcessoVincularLote";
import { IColum } from "containers/Table/interfaces";
import { useEffect, useState } from "react";

interface IProps {
  clearRows: boolean;
  setRowsSelected: (ids: number[]) => void;
  dados: IProcessoVincularLote[];
  selectedRows: number[];
  onClickAddCusto: () => void;
  tela: string;
}
export function ListaProcessosVincularLote({
  clearRows,
  setRowsSelected,
  dados,
  selectedRows,
  onClickAddCusto,
  tela,
}: IProps) {
  const [dadosTabela, setDadosTabela] = useState<IProcessoVincularLote[]>([
    ...dados,
  ]);
  const [textoBusca, setTextoBusca] = useState<string>("");
  const onChangePesquisa = (buscar: string) => {
    if (!buscar) {
      setDadosTabela([...dados]);
      return;
    }

    setDadosTabela(
      [...dados].filter((item) => {
        if (
          `${item.idProcesso}`.includes(buscar) ||
          (item.placa &&
            item.placa.replace("-", "").includes(buscar.replace("-", "")))
        ) {
          return true;
        }
        return false;
      })
    );
  };

  useEffect(() => {
    setTextoBusca("");
    setDadosTabela(dados);
  }, [dados]);

  const columns: IColum<IProcessoVincularLote>[] = [
    {
      name: "Processo",
      selector: ({ idProcesso }: IProcessoVincularLote) => idProcesso,
    },
    {
      name: "Placa",
      selector: ({ placa }: IProcessoVincularLote) => placa ?? "--",
    },
    {
      name: "Chassi",
      selector: ({ chassi }: IProcessoVincularLote) => chassi ?? "--",
      width: "200px",
    },
    {
      name: "Empresa",
      selector: ({ nomeEmpresa }: IProcessoVincularLote) => nomeEmpresa ?? "--",
      width: "200px",
    },
    {
      name: "Divisão",
      selector: ({ nomeDivisao }: IProcessoVincularLote) => nomeDivisao ?? "--",
      width: "200px",
    },
    {
      name: "Centro de custo",
      selector: ({ nomeCentroCusto }: IProcessoVincularLote) =>
        nomeCentroCusto ?? "--",
      width: "200px",
    },
    {
      name: "Serviços",
      selector: ({ servico }: IProcessoVincularLote) => servico ?? "--",
      width: "250px",
    },
  ];

  return (
    <Container>
      <Header>
        <TextoHeader>
          Selecione o(s) processos(s) em que deseja adicionar o custo
        </TextoHeader>
        <DivAcoes>
          <Button
            variante="primary"
            onClick={onClickAddCusto}
            disabled={!selectedRows.length}
          >
            Adicionar custo
          </Button>
        </DivAcoes>
      </Header>
      <hr />
      <ContainerInputPesquisa>
        <InputWrapper>
          <Icon />
          <InputPesquisa
            value={textoBusca}
            onChange={(e) => {
              setTextoBusca(e.target.value);
              onChangePesquisa(e.target.value);
            }}
            placeholder="ID Processo ou placa"
          />
        </InputWrapper>
      </ContainerInputPesquisa>
      <Table
        key={tela}
        keyField="idProcesso"
        columns={columns}
        data={dadosTabela}
        loading={false}
        noSubHeader
        possuiTooltip={false}
        selectableRows
        setRowsSelected={setRowsSelected}
        headerFixo
        clearSelectedRows={clearRows}
      />
    </Container>
  );
}
